import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAppSelector } from '../../../redux/storeExports';
import scanningAnimation from '@meprism/shared/src/assets/lottie/scan.gif';
import shield from '@meprism/shared/src/assets/icons/business_userscan.svg';
import shieldTick from '@meprism/shared/src/assets/icons/shield-tick.svg';

import {ProfileSelectors} from "@meprism/shared/src/redux/profile/ProfileSlice";

const SCAN_ACTIVE_THRESHOLD_HOURS = 3;
export const ScanWidget = () => {
  const profile = useAppSelector(ProfileSelectors.selectProfile);
  const lastScanStart = profile?.last_scan_initiated_at;

  if (!lastScanStart) {
    return null;
  }

  const lastScanStartDate = new Date(lastScanStart);
  const currentTime = new Date();
  const hoursDifference = (currentTime.getTime() - lastScanStartDate.getTime()) / (1000 * 60 * 60);

  if (hoursDifference < SCAN_ACTIVE_THRESHOLD_HOURS) {
    return (
      <Box sx={{ alignItems: 'flex-end', flexDirection: 'column', display: 'flex' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <img src={scanningAnimation} width='24px' alt="scanning" />
          <Typography
            variant={'body2'}
            sx={{
              color: 'caption',
              marginLeft: '10px',
              display: { sm: 'block', xs: 'none' },
              fontFamily: 'InterRegular',
              fontSize: 14,
              fontWeight: 400,
            }}
          >
            Scanning 600 data broker websites…
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between ',
      width: '100%',
      }}>
      <Box sx={{display: 'flex',alignItems: 'center' }}>
        <img
          src={shieldTick}
          alt="Shield Tick"
          style={{
            width: '24px',
            height: '24px',
            display: 'block',
            margin: 'auto',
            marginRight: '10px'
          }}
        />
        <Typography
          sx={{
            display: { xs: 'none', sm: 'block' },
            fontFamily: 'InterRegular',
            fontSize: 14,
            fontWeight: 400,
          }}
        >
          Scanning Done
        </Typography>

      </Box>
      <Box sx={{display: 'flex',alignItems: 'center' }}>
        <img
          src={shield}
          alt="shield"
          style={{
            width: '24px',
            height: '24px',
            display: 'block',
            margin: 'auto',
            marginRight: '10px'
          }}
        />
       <Typography
           sx={{
            fontFamily: 'InterRegular',
            fontSize: 14,
            fontWeight: 400,
            display: { xs: 'none', sm: 'block' }
          }}
        >
          Next scan date:{' '}
          {new Date(new Date(lastScanStartDate).setMonth(lastScanStartDate.getMonth() + 1)).toLocaleDateString()}
        </Typography>
      </Box>

    </Box>
  );
};